export default {
  methods: {
    checkIsWalletConnect(payload) {
      return payload && payload.isWalletConnect;
    },
  },
};
